import { Helmet } from "react-helmet-async";

const BASE_URL = "https://easylister.dishant-chudasama.com";
const DEFAULT_OG_IMAGE = "https://customer-assets.emergentagent.com/job_3c9098ac-8831-4027-87d1-54f7344062d7/artifacts/n5iswl94_Logo.png";

export const PageMeta = ({
  title,
  description,
  keywords,
  path = "/",
  ogTitle,
  ogDescription,
  twitterTitle,
  twitterDescription,
  jsonLd,
}) => {
  const canonical = `${BASE_URL}${path}`;
  const resolvedOgTitle = ogTitle || title;
  const resolvedOgDesc = ogDescription || description;
  const resolvedTwTitle = twitterTitle || resolvedOgTitle;
  const resolvedTwDesc = twitterDescription || resolvedOgDesc;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={resolvedOgTitle} />
      <meta property="og:description" content={resolvedOgDesc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={DEFAULT_OG_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTwTitle} />
      <meta name="twitter:description" content={resolvedTwDesc} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};
